<lang-change></lang-change>
<div class="container login-container">
    <div class="card card-container">
        <p id="profile-name" class="profile-name-card" i18n> User Profile </p>
    <form name="form" (ngSubmit)="f.form.valid && update()" #f="ngForm" novalidate>

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <label for="username" i18n>Username</label>
            <input type="text" class="form-control" name="username" [(ngModel)]="model.username" #username="ngModel" readonly id="username"/>
            <div *ngIf="f.submitted && !username.valid" class="help-block" i18n>Username is required</div>
        </div>

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !first_name.valid }">
            <label for="first_name" i18n>First Name</label>
            <input type="text" class="form-control" name="first_name" [(ngModel)]="model.first_name" #first_name="ngModel" value= "model.first_name" required id="first_name" />
            <div *ngIf="f.submitted && !first_name.valid" class="help-block" i18n>First Name is required</div>
        </div>

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !last_name.valid }">
            <label for="last_name" i18n>Last Name</label>
            <input type="text" class="form-control" name="last_name" [(ngModel)]="model.last_name" #last_name="ngModel" required id="last_name"/>
            <div *ngIf="f.submitted && !last_name.valid" class="help-block" i18n>Last Name is required</div>
        </div>

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !email.valid }">
            <label for="email" i18n>Email</label>
            <input type="text" class="form-control" name="email" [(ngModel)]="model.email" #email="ngModel" required id="email"/>
            <div *ngIf="f.submitted && !email.valid" class="help-block" i18n>Email is required</div>
        </div>

        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !organization.valid }">
            <label for="organization" i18n>Organization</label>
            <input type="text" class="form-control" name="organization" [(ngModel)]="model.organization" #organization="ngModel" required id="organization"/>
            <div *ngIf="f.submitted && !organization.valid" class="help-block" i18n>organization is required</div>
        </div>

        <div class="form-group">
            <button  class="btn btn-primary btn-radius btn-block" i18n>Update</button>
            <a [routerLink]="['/home']" class="btn btn-default btn-block btn-radius" i18n>Cancel</a>
        </div>
    </form>
</div><!-- /card-container -->
</div><!-- /container -->




// WEBPACK FOOTER //
// ./src/app/profile/profile.component.html